import { render, staticRenderFns } from "./RunsTableView.vue?vue&type=template&id=052a44a2&scoped=true&"
import script from "./RunsTableView.vue?vue&type=script&lang=ts&"
export * from "./RunsTableView.vue?vue&type=script&lang=ts&"
import style0 from "./RunsTableView.vue?vue&type=style&index=0&id=052a44a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052a44a2",
  null
  
)

export default component.exports